import React, { FC } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { WithColor } from '@styles/colors';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

interface LinearProgressProps extends WithColor {
  percent: number;
  width?: number;
  height?: number;
  trackColor?: string;
  fillColor?: string;
  scale?: ScaleFunction;
}

const LinearProgress: FC<LinearProgressProps> = ({
  percent,
  width = 330,
  height = 6,
  trackColor = 'Gray/Light/5',
  fillColor = 'System/Light/Blue',
  scale = initialScale,
  C,
}) => {
  const clampedPercent = Math.min(Math.max(percent, 0), 100);

  return (
    <View
      style={{
        height: scale(height),
        width: scale(width),
        borderRadius: scale(height / 2),
        backgroundColor: C(trackColor),
        overflow: 'hidden',
      }}
    >
      <View
        style={{
          height: '100%',
          width: `${clampedPercent}%`,
          borderRadius: scale(height / 2),
          backgroundColor: C(fillColor),
        }}
      />
    </View>
  );
};

export default LinearProgress;
